import React, { useEffect } from 'react';

const useUnmount = onUnmount => {
    useEffect(() => onUnmount, []);
};

export default useUnmount;
